import React, { useState } from "react";
import styles from "./SyncedDataTab.module.css";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { resetSaveImportedDataSuccess } from "../../service/importSlice";
import ImportTab from "./ContactTabs/ImportTab";
import { getSubDomainAccessStatus } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";

function ImportData(props: any) {
  const {
    contactList,
    contactListLoading,
    GetContactLists,
    DeleteContactList,
    deleteContactLoading,
    deleteContactSuccess,
    deleteContactError,
    GetBranchList,
    GetCourseList,
    GetBatchList,
    GetNurtureLeadBoard,
    CreateEnquiry,
    addedEnquiryContactSuccess,
    addedEnquiryContactError,
    addedEnquiryContactLoading,
    AddEnquiryForContact,
    emailConfigLoading,
    emailConfigSuccess,
    GetInstituteById,
    GetCourseById,
    GetBatchById,
    mailConfigsList,
    GetMailConfigList,
    saveImportedDataSuccess,
    CreateSource,
    type,
    leadCreatedId,
  } = props;

  const auth = useAuthUser();
  const authUser = auth();
  const dispatch = useDispatch();

  const importedSuccess = useSelector(
    (state: any) => state.importData.saveImportedDataSuccess
  );
  const { userById } = useSelector((state: any) => state.userDetails);
  const [limitForContactSelected, setLimitForContactSelected] = useState<any>({
    name: "10",
    value: 10,
  });
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission
  );

  React.useEffect(() => {
    const userFromLocalStorage = authUser?.institute[0];
    const lastEvaluatedKey = "";
    const limit = 15;
    const lastEvaluatedSortKey = "";
    const enquirySource = "Excel Import";
    if (userFromLocalStorage) {
      GetContactLists(
        userFromLocalStorage?.instituteId,
        lastEvaluatedKey,
        limitForContactSelected?.value === "ALL"
          ? 10
          : limitForContactSelected?.value,
        lastEvaluatedSortKey,
        enquirySource,
        !hasAllBranchAccess ? userById?.branchId : ""
      );
    }
  }, [GetContactLists, limitForContactSelected]);

  React.useEffect(() => {
    if (importedSuccess) {
      dispatch(resetSaveImportedDataSuccess());
    }
  }, [importedSuccess]);

  return (
    <div style={{ width: "100%", padding: "30px 20px" }}>
      <ImportTab
        contactList={contactList}
        contactListLoading={contactListLoading}
        DeleteContactList={DeleteContactList}
        deleteContactLoading={deleteContactLoading}
        deleteContactSuccess={deleteContactSuccess}
        deleteContactError={deleteContactError}
        CreateEnquiry={CreateEnquiry}
        AddEnquiryForContact={AddEnquiryForContact}
        addedEnquiryContactSuccess={addedEnquiryContactSuccess}
        addedEnquiryContactError={addedEnquiryContactError}
        GetContactLists={GetContactLists}
        GetInstituteById={GetInstituteById}
        GetCourseById={GetCourseById}
        GetBatchById={GetBatchById}
        page="IMPORT"
        leadCreatedId={leadCreatedId}
        limitForContactSelected={limitForContactSelected}
        setLimitForContactSelected={setLimitForContactSelected}
      />
    </div>
  );
}

export default ImportData;
